import React, { useContext, useState, useRef } from "react";
import { UserContext } from "../../providers/UserProvider";
import { firestore } from "../../firebase";
import NavBar from "../../components/NavBar";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import { Card, Accordion, Button } from "react-bootstrap";

import "./style.css";

const MyLeads = () => {
  const user = useContext(UserContext);
  const [userData, setUserData] = useState("");
  const [myLeadsData, setMyLeadsData] = useState("");
  const userRef = firestore.collection("usersData");
  const leadsRef = firestore.collection("leadsData");
  const leadsDocTemp = [];

  React.useEffect(() => {
    userRef
      .doc(user.uid)
      .get()
      .then((doc) => {
        if (doc.exists) {
          let data = doc.data();
          setUserData(data);
        } else {
          // doc.data() will be undefined in this case
          setUserData(null);
          console.log("No such document!");
        }
      })
      .catch(function (error) {
        setUserData(null);
        console.log("Error getting document:", error);
      });
  }, []);

  React.useEffect(() => {
    leadsRef
      .where("userId", "==", user.uid)
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          leadsDocTemp.push(doc.data());
        });
        setMyLeadsData(leadsDocTemp);
      })
      .catch(function (error) {
        console.log("Error getting documents: ", error);
      });
  }, []);

  if (!userData || !myLeadsData) return <div>Loading Data</div>;

  const sections = [
    { title: "פרופיל", url: "/Profile" },
    { title: "אח בוגר", url: "#" },
    { title: "פורום מקצועי", url: "#" },
    { title: "הפניות תיקים", url: "/SearchLead" },
  ];

  return (
    <div>
      <CssBaseline />
      <Container maxWidth="lg">
        <NavBar sections={sections} />
      </Container>
      <hr />

      <div className="myleads-page-cards-wrapper">
        <Accordion defaultActiveKey="0">
          {myLeadsData.map((lead, index) => (
            <Card>
            {console.log(lead)}
              <Card.Header className="qa-header">
                <Accordion.Toggle as={Button} variant="link" eventKey={index}>
                  <i className="fa fa-plus qa-plus-icon" aria-hidden="true"></i>
                  {lead.leadTitle}
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey={index}>
                <Card.Body className="qa-body">מיקום התיק: {lead.leadLocation} <br/><br/>
                תיאור: {lead.leadDescription} <br/><br/>
                התמחות: {lead.leadExp} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                כמות הגשות: {lead.numberOfSubmits || '0'}<br/><br/>
                
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default MyLeads;
